import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {BasicEpic} from './basic.epic';
import {ConfigService} from '../services/config.service';
import {ConfigActions} from '../actions/config.actions';
import {StoreActionsEnum} from '../../../modules/hbs-services';

@Injectable()
export class ConfigEpics extends BasicEpic {

    protected epicNames = [
        'loadConfig'
    ];


    constructor(private configService: ConfigService) {
        super();
    }

    private loadConfig = BasicEpic.createEpic(
        StoreActionsEnum.LOAD_CONFIG,
        ({payload}) => {
            return this.configService
                .loadConfig(payload.forSignedUser)
                .pipe(
                    map(ConfigActions.configLoaded)
                );
        });

}
